import { Module } from 'vuex'

import { HistoryPageStateModuleName } from '../modules'

import { GetUserJudgeHistoryUseCase } from '@/application/history/getUserJudgeHistoryUseCase'
import { JudgeRecord } from '@/domain/entities/judge/judgeRecord'
import { HistoryRepository } from '@/domain/repositories/history/historyRepository'

interface HistoryListState {
  historyList: { [judgeId: number]: JudgeRecord }
  isLoading: boolean
  error: Error | null
}

export const historyModule = (historyRepository: HistoryRepository): Module<HistoryListState, any> => {
  const getUserJudgeHistoryUseCase = new GetUserJudgeHistoryUseCase(historyRepository)

  return {
    namespaced: true,
    state: {
      historyList: {},
      isLoading: false,
      error: null
    },
    mutations: {
      setHistoryList(state, { list }: { list: { [judgeId: number]: JudgeRecord } }) {
        state.historyList = list
      },
      setHistoryListItem(state, { item }: { item: JudgeRecord }) {
        state.historyList[item.judgeId] = item
      },
      setIsLoading(state, isLoading: boolean) {
        state.isLoading = isLoading
      },
      setError(state, error: Error | null) {
        state.error = error
      }
    },
    actions: {
      async fetchHistoryList(
        { state, commit },
        { userId, problemId, pageIndex }: { userId: string; problemId: string; pageIndex: number }
      ) {
        commit('setIsLoading', true)
        commit('setError', null)

        try {
          const data = await getUserJudgeHistoryUseCase.getUserJudgeHistory(userId, problemId, pageIndex)
          data.forEach(item => {
            commit('setHistoryListItem', { item })
          })
          if (data.length === 0) {
            commit(`${HistoryPageStateModuleName}/setIsNotMoreHistoryList`, { flag: true }, { root: true })
          }
        } catch (error) {
          commit('setError', error)
        } finally {
          commit('setIsLoading', false)
        }
      }
    },
    getters: {
      historyList: state => state.historyList,
      isLoading: state => state.isLoading,
      error: state => state.error
    }
  }
}
